module.exports = __webpack_public_path__ + "static/media/flags.e43a95fe.svg";